import React from 'react'
import { withModal } from '../'

class Modal extends React.Component {
  componentDidMount() {
    document.querySelector('html').classList.add('hide-scroll')
  }

  componentWillUnmount() {
    document.querySelector('html').classList.remove('hide-scroll')
  }

  render() {
    if(this.props.modal.current !== this.props.path) return null

    const Component = this.props.component
    return <Component {...this.props} data={this.props.modal.data} />
  }
}

export default withModal(Modal)
